import { createTheme, type MantineColorsTuple } from '@mantine/core';
import { color, font, radius } from './tokens';

// Ten shades around the design's link blue (#1E56C8 at index 6).
const blue: MantineColorsTuple = [
  '#EAF0FC',
  '#D3E0F8',
  '#A6C1F1',
  '#749FE9',
  '#4C82E2',
  '#3270DD',
  '#1E56C8',
  '#1A4BB0',
  '#163F94',
  '#10316F',
];

// Ten shades around the console's amber mark (#F2A93B at index 5).
const amber: MantineColorsTuple = [
  '#FEF6E9',
  '#FCEBD0',
  '#F9D6A0',
  '#F6C16C',
  '#F4B04A',
  '#F2A93B',
  '#D9922A',
  '#B5781F',
  '#8A4B00',
  '#5E3300',
];

export const theme = createTheme({
  fontFamily: font.sans,
  fontFamilyMonospace: font.mono,
  headings: { fontFamily: font.sans, fontWeight: '700' },
  primaryColor: 'blue',
  colors: { blue, amber },
  defaultRadius: radius.control,
  black: color.text,
  components: {
    Button: { defaultProps: { size: 'md' } },
    TextInput: { defaultProps: { size: 'md' } },
    PasswordInput: { defaultProps: { size: 'md' } },
  },
});
